<template>
  <b-modal id="change-password-modal" ref="change-password-modal" no-close-on-backdrop no-stacking @close="resetModal">
    <template slot="modal-title"> {{ $t('changePassword') }}</template>
    <form ref="form" v-on:submit.prevent autocomplete="off">
      <b-col>
        <Password
          :id="changePasswordRequest.newPassword"
          :label="$t('password')"
          :value="changePasswordRequest.newPassword"
          v-model="changePasswordRequest.newPassword"/>
      </b-col>
      <b-col>
        <Password
          :id="changePasswordRequest.confirmPassword"
          :label="$t('confirmPassword')"
          :value="changePasswordRequest.confirmPassword"
          v-model="changePasswordRequest.confirmPassword"/>
        <b-form-invalid-feedback id="checkSamePasswords-feedback" v-if="changePasswordRequest.confirmPassword" :state="this.checkIfSamePasswords()">
          {{ $t('passwordsNotIdentical')}}
        </b-form-invalid-feedback>
      </b-col>
    </form>

    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="changePassword" :disabled="isButtonDisabled">{{ $t('update') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
  import UserService from '../../services/UserService'
  import Password from '../../components/Password';

  export default {
    components: {
      Password
    },
    data () {
      return {
        changePasswordRequest: {
          newPassword: null,
          confirmPassword: null,
        },
        isButtonDisabled: true
      }
    },
    methods: {
      onKeyup () {
        this.checkIfSamePasswords()
      },
      resetModal () {
        this.changePasswordRequest.newPassword = ''
        this.changePasswordRequest.confirmPassword = ''
        this.isButtonDisabled = true
        this.$refs['change-password-modal'].hide()
      },
      checkIfSamePasswords () {
        let newPassword = this.changePasswordRequest.newPassword
        let confirmPassword = this.changePasswordRequest.confirmPassword
        if (newPassword === confirmPassword && newPassword.length >= 8) {
          this.isButtonDisabled = false
          return true
        } else {
          this.isButtonDisabled = true
          return false
        }
      },
      changePassword () {
        let that = this
        let request = {
          userId: this.$route.params.id,
          password: this.changePasswordRequest.confirmPassword
        }
        UserService.changeUserPassword(request)
          .then(function () {
            that.$root.$emit('bv::hide::change-password-modal')
            that.resetModal()
          })
      }
    }
  }

</script>
